var redirecting = false;
if (typeof sessionStorage.apitoken === "undefined") {
	redirecting = true;
	var params = window.location.search
	window.location = "/login/?r=" + window.location.pathname + (params ? ("&" + params.slice(1)) : "") + window.location.hash;
}

module.exports = redirecting;